import space from '@styled-system/space'
import typography from '@styled-system/typography'
import { em } from 'polished'
import styled from 'styled-components'

import DynamicImage from 'components/DynamicImage'
import { BoxBase, Col } from 'styles/components/layout'

const threshold = '768px'

export const BoxBaseStyled = styled(BoxBase)`
  display: flex;
  flex-direction: column-reverse;
  color: ${p => p.theme.colors.white};
  overflow: hidden;
  position: relative;
  padding-top: ${em(80)};
  padding-bottom: ${em(80)};
  background-color: #63CEDD;
  text-align: center;
  @media (min-width: ${threshold}) {
    flex-direction: row;
    text-align: left;
  }
`

export const ColStyled = styled(Col)`
  position: relative;
  ${space};
  ${typography};
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ColCentered = styled(Col)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: ${em(50)};
`

export const ImageWrapper = styled('div')`
  position: relative;
`

export const DynamicImageStyled = styled(DynamicImage)`
  display: block;
  max-width: ${em(350)};
  margin: 0 auto;

  ${p => p.theme.mq.upMd} {
    height: inherit;
    object-position: left top;
    max-width: initial;
    margin: 0;
  }
`

export const VideoWrapper = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const IframeStyled = styled('iframe')`
  position: relative;
  height: 50vw;
  width: 90%;
`

export const ExitArea = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

export const ButtonWrapper = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
